import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

interface ISubmitButtonProps {
  onClick: () => void;
  text: string;
  secondaryText?: string;
  boldedText?: string;
  variant?: 'dark' | 'light';
  className?: any;
  loading?: boolean;
  disabled?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonBase: {
      width: '100%',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      borderRadius: '5px',
      textTransform: 'none',
      fontWeight: 'normal',
      textAlign: 'center',
      border: 'solid 1px',
    },
    lightButton: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.default,
        borderColor: theme.palette.background.default,
      },
    },
    darkButton: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.background.default,
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.default,
      },
    },
    innerContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    topRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
    bottomRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
    },
  }),
);

export default function SubmitButton(
  props: ISubmitButtonProps,
) {
  const { onClick, text, secondaryText, boldedText, variant = 'dark', className = '',
      loading = false , disabled = false} = props;
  const classes = useStyles(baseTheme);

  return (
    loading ?
      <CircularProgress color="secondary" />
      :
      <Button
        className={
          `${classes.buttonBase}
        ${variant === 'dark' ? classes.darkButton : classes.lightButton}
        ${className}`
        }
        disabled={loading || disabled}
        onClick={onClick}>
        <div className={classes.innerContainer}>
          <div className={classes.topRow}>
            {text}&nbsp;<b>{boldedText}</b>
          </div>
          <div className={classes.bottomRow}>
            {secondaryText}
          </div>
        </div>
      </Button>
  );
}
